import { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import ColorPickerPopover from 'ContentComponents/components/cmv2/components/ColorPickerPopover';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import { ColorInput } from 'foundations-components/transitional/components/ColorInput';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import GoogleFontOption from 'ContentComponents/components/cmv2/fontPicker/GoogleFontOption';
import CustomFontOption from 'ContentComponents/components/cmv2/fontPicker/CustomFontOption';
import BrandingCustomFontOption from 'ContentComponents/components/cmv2/fontPicker/BrandingCustomFontOption';
import FontFamilyPicker from 'ContentComponents/components/cmv2/fontPicker/FontFamilyPicker';
import SanitizedLabel from 'ContentComponents/components/cmv2/SanitizedLabel';
import { DEFAULT_STYLES, FONT_FORMAT_LIST as SYSTEM_FONTS, FONT_SETS, FONT_SIZE_UNITS, FONT_STYLES, REGULAR_GOOGLE_FONT_VARIANT, UNSUPPORTED_FONTS } from 'ContentUtils/constants/Fonts';
import { FONT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import HiddenSubfieldTypes from 'ContentUtils/constants/HiddenSubfieldTypes';
import { getDefaultVariant, formatVariant } from 'ContentComponents/components/cmv2/fontPicker/utils';
import * as fontsSelectors from 'ContentData/selectors/fonts';
import { ABSOLUTE_SIZE_UNIT_STEP_SIZE, RELATIVE_SIZE_UNITS, RELATIVE_SIZE_UNIT_STEP_SIZE } from '../constants';
import { FONT_STYLE_OPTIONS } from '../../../constants/FontsConstants';
import text from 'I18n/utils/unescapedText';
import { Box } from 'foundations-components/transitional/components/Box';
import { ItalicIcon } from 'foundations-assets';
import { BoldIcon } from 'foundations-assets';
import { UnderlineIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.font.${key}`;
const mapStateToProps = state => ({
  selectedCustomFonts: fontsSelectors.getSelectedCustomFonts(state),
  selectedGoogleFonts: fontsSelectors.selectedGoogleFonts(state)
});
const connector = connect(mapStateToProps);
const FONT_HIDDEN_SUBFIELD_TYPES = HiddenSubfieldTypes[FONT];
const SYSTEM_FONT_VALUES = Object.values(SYSTEM_FONTS || {});
const SYSTEM_FONT_KEYS = Object.keys(SYSTEM_FONTS || {});
const UNSUPPORTED_FONT_VALUES = Object.values(UNSUPPORTED_FONTS || {});
const styleIconMap = {
  UNDERLINE: /*#__PURE__*/_jsx(UnderlineIcon, {
    size: "300"
  }),
  BOLD: /*#__PURE__*/_jsx(BoldIcon, {
    size: "300"
  }),
  ITALIC: /*#__PURE__*/_jsx(ItalicIcon, {
    size: "300"
  })
};
class FontPickerField extends PureComponent {
  constructor(props) {
    super(props);
    this.renderDisplayVariant = (font_set, defaultFont, variant) => {
      switch (font_set) {
        case FONT_SETS.CUSTOM:
          return this.renderCustomFont(defaultFont, this.font, variant);
        case FONT_SETS.BRANDING:
          return this.renderBrandingCustomFont(defaultFont, this.font, variant.name);
        default:
          return this.renderGoogleFont(defaultFont, this.font, variant);
      }
    };
    this.renderVariantText = (font_set, variant) => {
      switch (font_set) {
        case FONT_SETS.CUSTOM:
          return variant;
        case FONT_SETS.BRANDING:
          return variant.name;
        default:
          return formatVariant(variant);
      }
    };
    this.fontSizeFormatter = this.fontSizeFormatter.bind(this);
    this.isStyleSelected = this.isStyleSelected.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onFontColorChange = this.onFontColorChange.bind(this);
    this.onFontSizeChange = this.onFontSizeChange.bind(this);
    this.onFontSizeUnitChange = this.onFontSizeUnitChange.bind(this);
    this.onStyleChange = this.onStyleChange.bind(this);
    this.onVariantSelect = this.onVariantSelect.bind(this);
    this.setOldStyleIfAvailable = this.setOldStyleIfAvailable.bind(this);
    this.style_order = FONT_STYLE_OPTIONS.map(styleKey => text(i18nKey(`modals.upload.edit.styleOptions.${styleKey.replace('-', '')}`)));
  }
  get seleniumKey() {
    const {
      fieldKey = []
    } = this.props;
    return fieldKey.join('.');
  }
  get shouldNotShowSizeUnit() {
    const {
      isEmailOrAnyType,
      showSizeUnit = false
    } = this.props;
    return isEmailOrAnyType || !showSizeUnit || this.hiddenSubfields[FONT_HIDDEN_SUBFIELD_TYPES.size_unit];
  }
  get sizeUnitOptions() {
    return Object.keys(FONT_SIZE_UNITS).map(unit => {
      return {
        value: unit,
        text: unit
      };
    });
  }
  get size() {
    const {
      value = {}
    } = this.props;
    const {
      size
    } = value || {};
    if (size && typeof size === 'object') {
      return size.value || null;
    }
    return size || null;
  }
  get sizeUnit() {
    const {
      value = {}
    } = this.props;
    const {
      size,
      size_unit
    } = value || {};
    const unit = size && typeof size === 'object' ? size.units : size_unit;
    return unit || FONT_SIZE_UNITS.px;
  }
  get hiddenSubfields() {
    const {
      visibility = {}
    } = this.props;
    return visibility.hidden_subfields || {};
  }
  get font() {
    const {
      value = {}
    } = this.props;
    return value && value.font ? value.font : null;
  }
  get color() {
    const {
      value = {}
    } = this.props;
    return value && value.color ? value.color : null;
  }
  get styles() {
    const {
      value = {}
    } = this.props;
    return value && value.styles ? value.styles : Object.assign({}, DEFAULT_STYLES);
  }
  get stepSize() {
    const {
      value = {}
    } = this.props;
    const {
      size_unit
    } = value || {};
    return RELATIVE_SIZE_UNITS[size_unit] ? RELATIVE_SIZE_UNIT_STEP_SIZE : ABSOLUTE_SIZE_UNIT_STEP_SIZE;
  }
  onFieldChange(newValue) {
    const {
      onFieldChange,
      value = {}
    } = this.props;
    onFieldChange(Object.assign({}, value, newValue));
  }
  onFontSizeChange({
    target: {
      value: inputSize
    }
  }) {
    const {
      value = {}
    } = this.props;
    const {
      size
    } = value || {};
    const sizeObject = typeof size === 'object' && size !== null ? {
      size: {
        value: inputSize,
        units: this.sizeUnit
      }
    } : {
      size: inputSize
    };
    this.onFieldChange(sizeObject);
  }
  onFontSizeUnitChange({
    target: {
      value: inputUnit
    }
  }) {
    const {
      value = {}
    } = this.props;
    const {
      size
    } = value || {};
    const sizeObject = typeof size === 'object' && size !== null ? {
      size: {
        value: this.size,
        units: inputUnit
      }
    } : {
      size: this.size,
      size_unit: inputUnit
    };
    this.onFieldChange(sizeObject);
  }
  onFontColorChange(e) {
    this.onFieldChange({
      color: e.target.value
    });
  }
  setOldStyleIfAvailable(styles, type, value) {
    const {
      useLegacyStyles = false
    } = this.props;
    if (typeof styles[type] !== 'undefined' || useLegacyStyles) {
      styles[type] = value;
    }
  }
  onStyleChange(style) {
    let currentStyles = this.styles;
    const isStyleSelected = this.isStyleSelected(style);
    this.setOldStyleIfAvailable(currentStyles, style, !isStyleSelected);
    switch (style) {
      case FONT_STYLES.UNDERLINE:
        currentStyles = Object.assign({}, currentStyles, {
          'text-decoration': isStyleSelected ? DEFAULT_STYLES['text-decoration'] : FONT_STYLES.UNDERLINE
        });
        break;
      case FONT_STYLES.BOLD:
        currentStyles = Object.assign({}, currentStyles, {
          'font-weight': isStyleSelected ? DEFAULT_STYLES['font-weight'] : FONT_STYLES.BOLD
        });
        break;
      case FONT_STYLES.ITALIC:
        currentStyles = Object.assign({}, currentStyles, {
          'font-style': isStyleSelected ? DEFAULT_STYLES['font-style'] : FONT_STYLES.ITALIC
        });
        break;
      default:
        break;
    }
    this.onFieldChange({
      styles: currentStyles
    });
  }
  isStyleSelected(style) {
    const currentStyles = this.styles;
    switch (style) {
      case FONT_STYLES.UNDERLINE:
        return !!(currentStyles['text-decoration'] === FONT_STYLES.UNDERLINE || currentStyles.underline);
      case FONT_STYLES.BOLD:
        return !!(currentStyles['font-weight'] === FONT_STYLES.BOLD || currentStyles.bold);
      case FONT_STYLES.ITALIC:
        return !!(currentStyles['font-style'] === FONT_STYLES.ITALIC || currentStyles.italic);
      default:
        return false;
    }
  }
  onVariantSelect(e) {
    this.onFieldChange({
      variant: e.target.value
    });
  }
  fontSizeFormatter(value) {
    const {
      isEmailOrAnyType,
      showSizeUnit = false
    } = this.props;
    if (!value) {
      return unescapedText(i18nKey('fontSizeUnit.default'));
    }
    if (!showSizeUnit || this.hiddenSubfields[FONT_HIDDEN_SUBFIELD_TYPES.size_unit] || isEmailOrAnyType) {
      return `${value}${this.sizeUnit}`;
    }
    return value.toString();
  }
  renderFontPicker() {
    const {
      childTheme,
      error = false,
      fieldKey = [],
      fontList,
      FontFamilyPickerComponent = FontFamilyPicker,
      fontPickerProps = {},
      isEmailOrAnyType,
      limited_options: limitedOptions,
      modulePath,
      readOnly,
      themePath,
      trackFieldAction,
      useOnDark,
      showCustomFonts = true,
      value = {},
      contentId,
      contentCategoryName,
      businessUnitId
    } = this.props;
    if (this.hiddenSubfields[FONT_HIDDEN_SUBFIELD_TYPES.font]) return null;
    return /*#__PURE__*/_jsx(Box, {
      grow: 1,
      children: /*#__PURE__*/_jsx(FontFamilyPickerComponent, {
        childTheme: childTheme,
        error: error,
        fieldKey: fieldKey,
        fontList: fontList,
        fontPickerProps: fontPickerProps,
        isEmailOrAnyType: isEmailOrAnyType,
        modulePath: modulePath,
        onFontFamilyChange: this.onFieldChange,
        readOnly: readOnly,
        themePath: themePath,
        trackFieldAction: trackFieldAction,
        useOnDark: useOnDark,
        value: value,
        showCustomFonts: showCustomFonts,
        limitedOptions: limitedOptions,
        contentId: contentId,
        contentCategoryName: contentCategoryName,
        businessUnitId: businessUnitId
      })
    });
  }
  renderFontSizePicker() {
    const {
      readOnly,
      fontSizeProps = {},
      useOnDark
    } = this.props;
    if (this.hiddenSubfields[FONT_HIDDEN_SUBFIELD_TYPES.size]) return null;
    return /*#__PURE__*/_jsx(Box, {
      basis: 104,
      children: /*#__PURE__*/_jsx(StepperInput, Object.assign({
        "aria-label": text(i18nKey('fontSizeUnit.default')),
        marginInlineStart: "100",
        "data-selenium": `${this.seleniumKey}:size`,
        formatter: this.fontSizeFormatter,
        onChange: this.onFontSizeChange,
        readOnly: readOnly,
        size: 3,
        stepSize: this.stepSize,
        use: useOnDark ? 'on-dark' : 'default',
        value: this.size || undefined
      }, fontSizeProps))
    });
  }
  renderFontSizeUnitPicker() {
    const {
      readOnly,
      useOnDark
    } = this.props;
    if (this.shouldNotShowSizeUnit) return null;
    return /*#__PURE__*/_jsx(View, {
      marginInlineStart: "100",
      maxInlineSize: "70px",
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('fontSizeUnit.label')
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('fontSizeUnit.tooltip')
        }),
        tooltipPlacement: 'top left',
        children: /*#__PURE__*/_jsx(Select, {
          buttonUse: useOnDark ? 'form-on-dark' : 'form',
          "data-selenium": `${this.seleniumKey}:unit`,
          value: this.sizeUnit,
          menuWidth: 75,
          onChange: this.onFontSizeUnitChange,
          options: this.sizeUnitOptions,
          readOnly: readOnly
        })
      })
    });
  }
  renderFontColorPicker() {
    const {
      readOnly,
      colorInputProps,
      ColorPicker = ColorPickerPopover,
      useOnDark
    } = this.props;
    const {
      inputProps = {},
      swatchProps = {}
    } = colorInputProps || {};
    if (this.hiddenSubfields[FONT_HIDDEN_SUBFIELD_TYPES.color]) return null;
    return /*#__PURE__*/_jsx(ColorInput, {
      ColorPicker: ColorPicker,
      color: this.color || undefined,
      onColorChange: this.onFontColorChange,
      readOnly: readOnly,
      showInput: false,
      use: useOnDark ? 'on-dark' : 'default',
      inputProps: Object.assign({}, inputProps, {
        'data-selenium': `${this.seleniumKey}:color_text`
      }),
      swatchProps: Object.assign({
        'aria-label': `${text(i18nKey('colorLabel'))}${this.color ? ` ${this.color}` : ''}`,
        'data-selenium': `${this.seleniumKey}:color_swatch`,
        'data-color': this.color || undefined
      }, swatchProps),
      marginInlineEnd: "200"
    });
  }
  renderStyleButtons() {
    const {
      readOnly,
      buttonSize
    } = this.props;
    return /*#__PURE__*/_jsx(ButtonGroup, {
      children: Object.keys(FONT_STYLES || {}).map(key => {
        const style = FONT_STYLES[key];
        const styleIcon = styleIconMap[key];
        if (this.hiddenSubfields[FONT_HIDDEN_SUBFIELD_TYPES[style]]) {
          return null;
        }
        return /*#__PURE__*/_jsx(IconButton, {
          "aria-label": text(i18nKey(`styles.${style}`)),
          active: this.isStyleSelected(style),
          "data-selenium": `${this.seleniumKey}:styles:${style}`,
          "data-selenium-active": this.isStyleSelected(style),
          disabled: readOnly,
          onClick: () => this.onStyleChange(style),
          size: buttonSize,
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`styles.${style}`)
          }),
          children: styleIcon
        }, style);
      })
    });
  }
  renderGoogleFont(font, fontFamily, variant) {
    const fontObject = font || {
      family: fontFamily
    };
    return /*#__PURE__*/_jsx(GoogleFontOption, {
      font: fontObject,
      variant: variant
    });
  }
  renderCustomFont(font, fontFamily, variant) {
    const fontObject = font || {
      family: fontFamily
    };
    return /*#__PURE__*/_jsx(CustomFontOption, {
      font: fontObject,
      variant: variant
    });
  }
  renderBrandingCustomFont(font, fontFamily, variant) {
    const fontObject = font || {
      family: fontFamily
    };
    return /*#__PURE__*/_jsx(BrandingCustomFontOption, {
      font: fontObject,
      variant: variant
    });
  }
  renderVariants() {
    const {
      buttonSize,
      readOnly,
      selectedCustomFonts,
      selectedGoogleFonts,
      useOnDark,
      value = {}
    } = this.props;
    const {
      font_set
    } = value || {};
    const defaultFont = font_set === FONT_SETS.CUSTOM || font_set === FONT_SETS.BRANDING ? selectedCustomFonts[this.font] : selectedGoogleFonts[this.font];
    if (!defaultFont) return this.renderStyleButtons();
    const hasInvalidVariantValue = !!value.variant && !!defaultFont.variants && !defaultFont.variants.find(variant => {
      const variantName = (variant === null || variant === void 0 ? void 0 : variant.name) || variant;
      return variantName === value.variant;
    });
    let currentVariant = value.variant || getDefaultVariant(defaultFont.variants);
    if (currentVariant === REGULAR_GOOGLE_FONT_VARIANT) {
      currentVariant = 'regular';
    }
    const variantOptions = defaultFont.variants.reduce((acc, variant) => {
      if (variant === 'Main') return acc;
      const displayVariant = this.renderDisplayVariant(font_set, defaultFont, variant);
      acc.push({
        value: font_set === FONT_SETS.BRANDING ? variant.name : variant,
        text: this.renderVariantText(font_set, variant),
        dropdownText: displayVariant,
        buttonText: displayVariant
      });
      return acc;
    }, []);

    //for branding custom fonts styles not sorted on BE, so sort from thinnest to boldest
    let variantOptionsSorted = variantOptions;
    if (font_set === FONT_SETS.BRANDING) {
      variantOptionsSorted = variantOptions.sort((a, b) => this.style_order.indexOf(a.value) - this.style_order.indexOf(b.value));
    }
    return /*#__PURE__*/_jsxs(TFlex, {
      children: [/*#__PURE__*/_jsx(Box, {
        grow: 1,
        children: /*#__PURE__*/_jsx(FormControl, {
          error: hasInvalidVariantValue,
          validationMessage: hasInvalidVariantValue && /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('invalidVariant')
          }),
          children: /*#__PURE__*/_jsx(Select, {
            "aria-label": text(i18nKey('variantSelectLabel')),
            buttonUse: useOnDark ? 'form-on-dark' : 'form',
            "data-selenium": `${this.seleniumKey}:variants`,
            defaultValue: currentVariant,
            onChange: this.onVariantSelect,
            options: variantOptionsSorted,
            readOnly: readOnly,
            searchable: false,
            value: currentVariant,
            blockSize: "40px"
          })
        })
      }), !this.hiddenSubfields[FONT_HIDDEN_SUBFIELD_TYPES.underline] && /*#__PURE__*/_jsx(IconButton, {
        "aria-label": text(i18nKey(`styles.underline`)),
        active: this.isStyleSelected('underline'),
        "data-selenium-active": this.isStyleSelected('underline'),
        "data-selenium": `${this.seleniumKey}:styles:underline`,
        disabled: readOnly,
        onClick: () => this.onStyleChange(FONT_STYLES.UNDERLINE),
        size: buttonSize,
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('styles.underline')
        }),
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(UnderlineIcon, {})
      }, "underline")]
    });
  }
  renderStylePicker() {
    if (this.hiddenSubfields[FONT_HIDDEN_SUBFIELD_TYPES.styles]) return null;
    return !this.font || SYSTEM_FONT_VALUES.includes(this.font) || SYSTEM_FONT_KEYS.includes(this.font) ? this.renderStyleButtons() : this.renderVariants();
  }
  renderUnsupportedFontsAlert() {
    const {
      value = {}
    } = this.props;
    const {
      font
    } = value || {};
    if (!UNSUPPORTED_FONT_VALUES.includes(font)) return null;
    const fontName = Object.keys(UNSUPPORTED_FONTS).find(fontKey => UNSUPPORTED_FONTS[fontKey] === font);
    const unsupportedFontLink = /*#__PURE__*/_jsx(Link, {
      external: true,
      href: "https://blog.hubspot.com/website/web-safe-html-css-fonts",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('unsupportedFontLink')
      })
    });
    return /*#__PURE__*/_jsx(Alert, {
      marginBlockStart: "200",
      type: "danger",
      "aria-label": text(i18nKey('unsupportedFontErrorLabel')),
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: i18nKey('unsupportedFontErrorText'),
        options: {
          fontName,
          unsupportedFontLink
        }
      })
    });
  }
  renderLabel() {
    const {
      label
    } = this.props;
    if (this.shouldNotShowSizeUnit) return null;
    return /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: this.seleniumKey,
      paddingBlockStart: "0",
      children: typeof label === 'string' ? /*#__PURE__*/_jsx(SanitizedLabel, {
        label: label
      }) : label
    });
  }
  render() {
    const {
      showFontFamilyPickerOnly = false
    } = this.props;
    if (showFontFamilyPickerOnly) return this.renderFontPicker();
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs(TFlex, {
        align: "end",
        children: [/*#__PURE__*/_jsxs(Box, {
          grow: 1,
          children: [this.renderLabel(), /*#__PURE__*/_jsxs(TFlex, {
            align: "stretch",
            children: [this.renderFontPicker(), this.renderFontSizePicker()]
          })]
        }), this.renderFontSizeUnitPicker()]
      }), /*#__PURE__*/_jsxs(TFlex, {
        align: "stretch",
        marginBlockStart: "200",
        children: [this.renderFontColorPicker(), this.renderStylePicker()]
      }), this.renderUnsupportedFontsAlert()]
    });
  }
}
export default connector(FontPickerField);